export const VIEWER_PANEL_ANNOTATION = 'VIEWER_PANEL_ANNOTATION';
export const VIEWER_PANEL_DIRECTION = 'VIEWER_PANEL_DIRECTION';
export const VIEWER_PANEL_INFO = 'VIEWER_PANEL_INFO';
export const VIEWER_PANEL_ORIENTATION = 'VIEWER_PANEL_ORIENTATION';
export const VIEWER_PANEL_REDACTION = 'VIEWER_PANEL_REDACTION';
